// 账户结单时间类型
export const STATEMENT_DATE_TYPE = {
  /** 月结单 */
  MONTHLY_STATEMENT: '1',
  /** 自定义时间 */
  CUSTOMIZED_TIME: '2',
};

// 导出创建场景码
export const EXPORT_CREATE_TYPE = {
  SUCCESS: 1,
  FAIL: 2,
};

// 导出状态
export const EXPORT_STATUS = {
  PROCESSING: 1,
  SUCCESS: 2,
  EXPIRED: 3,
  FAILED: 4,
  EMPTY: 5,
};

// 导出状态对应颜色
export const EXPORT_STATUS_TMS = {
  [EXPORT_STATUS.PROCESSING]: {
    tms: 'generateInProgress',
    color: '#F7A600',
    msg: 'pleaseWait',
    hasDownload: false,
  },
  [EXPORT_STATUS.SUCCESS]: {
    tms: 'generatedSuccessfully',
    color: '#20B26C',
    msg: '',
    hasDownload: true,
  },
  [EXPORT_STATUS.EXPIRED]: {
    tms: 'exportLimitExceeded',
    color: '#D5DAE0',
    msg: '',
    hasDownload: false,
  },
  [EXPORT_STATUS.FAILED]: {
    tms: 'generateFail',
    color: '#EF454A',
    msg: '',
    hasDownload: false,
  },
  [EXPORT_STATUS.EMPTY]: {
    tms: 'generateEmpty',
    color: '#20B26C',
    msg: '',
    hasDownload: false,
  },
};

// 导出类型
export const EXPORT_TYPE = {
  /** 默认导出 账户类汇总导出 */
  DEFAULT_EXPORT: 0,
  /** 资产结单 */
  ACCOUNT_STATEMENT: 1,
};
